import img1 from "./WhatsApp Image 2025-11-27 at 1.54.31 PM (1).jpeg";
import img2 from "./WhatsApp Image 2025-11-27 at 1.54.31 PM (2).jpeg";
import img3 from "./WhatsApp Image 2025-11-27 at 1.54.31 PM.jpeg";
import img4 from "./WhatsApp Image 2025-11-27 at 1.54.34 PM (1).jpeg";
import img5 from "./WhatsApp Image 2025-11-27 at 1.54.34 PM.jpeg";
import img6 from "./WhatsApp Image 2025-11-27 at 1.54.35 PM.jpeg";

export default [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
];
